import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-email-sending-spinner',
  templateUrl: './email-sending-spinner.component.html',
  styleUrls: ['./email-sending-spinner.component.css']
})
export class EmailSendingSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
